export default {"src":"/_next/static/media/undraw_collaborators_re_hont.6cb14b6e.svg","height":624,"width":989};